export const newsForm = {
    subType: {
        type: {
            mandatory: true,
            value: null,
        },
    },
    mainInfo: {
        cover: {
            value: { src: null, id: null, file: null },
            mandatory: true,
        },
        title: {
            mandatory: true,
            value: '',
        },
        department: {
            mandatory: true,
            value: null,
        },
        recipient: {
            mandatory: true,
            value: [],
        },
        info: {
            value: null,
        },
        attachmentList: {
            value: [],
        },
        confirmRead: {
            value: null,
        },
        messagingEnabled: {
            value: null,
        },
        commentReaction: {
            value: null,
        },
    },
    distribution: {
        listName: {
            value: '',
        },
        selectedDistributionList: {
            value: null,
        },
        selectedStoreList: {
            value: [],
            mandatory: true,
        },
    },
    pointsAssignment: {
        badge: {
            value: null,
            mandatory: true,
        },
        points: {
            value: null,
            mandatory: true,
        },
    },
    scheduling: {
        startDate: {
            value: null,
            mandatory: true,
        },
        endDate: {
            value: null,
            mandatory: true,
        },
        projectVisibility: {
            value: null,
            mandatory: true,
        },
        daysBefore: {
            value: null,
        },
        specificDate: {
            value: null,
        },
        priority: {
            value: null,
            mandatory: true,
        },
        autoClose: {
            value: null,
        },
        autoCloseDays: {
            value: null,
        },
        recurring: {
            value: null,
        },
        calendarVisibility: {
            value: false,
        },
        recurringType: {
            value: null,
        },
        recurringEvery: {
            value: null,
        },
        recurringOn: {
            value: null,
        },
        recurringUntil: {
            value: null,
        },
        recurringOccurrency: {
            value: null,
        },
        recurringStartDate: {
            value: null,
        },
        recurringEndDate: {
            value: null,
        },
    },
}
